package org.moxultimate.topwithmox.statics

/**
 * WallpaperStatics
 * Central registry for all static strings, asset paths, and filter lists
 * used across the WallpaperPage and WallpaperDetailsPage.
 */
object WallpaperStatics {

//----- Filter Types ---------------------------------------------------------------------------------------------------

    /** Ordered list of wallpaper type chips shown at the top of the page. */
    val ALL_TYPES = listOf("Phone", "Desktop", "Widescreen", "Vertical")

//----- Page Heading ---------------------------------------------------------------------------------------------------

    const val PAGE_SUBTITLE      = "FREE · 4K · 8K RESOLUTION"
    const val PAGE_TITLE_LINE1   = "TOP"
    const val PAGE_TITLE_LINE2   = "Wallpapers"
    const val PAGE_DESCRIPTION   = "Weekly update for new wallpapers. Follow TopWithMox channel in Youtube or Facebook to see latest updates"

    const val PAGE_DETAIL_1      = "Latest"
    const val PAGE_DETAIL_TYPE1  = "Frieren Series"
    const val PAGE_DETAIL_2      = "10K+"
    const val PAGE_DETAIL_TYPE2  = "Downloads"
    const val PAGE_DETAIL_3      = "50+ New"
    const val PAGE_DETAIL_TYPE3  = "Wallpapers"

//----- Search Bar -----------------------------------------------------------------------------------------------------

    const val SEARCH_PLACEHOLDER = "Search Wallpapers"

}
